import React, { Fragment, h } from "preact";
import {Card} from '../../_common/layout'
import {t} from '../../_i18n'
import AlertBox from "../../_common/components/AlertBox/AlertBox";
import {ButtonGhost} from "../../_common/components/buttons/buttons";
import {formatDateLong} from "../../utils";

export default function EnrollsList({type, enrollsInPeriod, onAction, className}) {
    const config = {
        pending: {
            title: t('Asignaturas sin aplazar'),
            noEnrollsText: t('no_enrolls_current_period'),
            buttonText: t('postpone_enroll'),
            formativeActionsKey: 'pending_formative_actions'
        },
        postponed: {
            title: t('Asignaturas aplazadas'),
            noEnrollsText: t('no_enrolls_next_period'),
            buttonText: t('activate_enroll'),
            formativeActionsKey: 'postponed_formative_actions'
        }
    };

    const { title, noEnrollsText, buttonText, formativeActionsKey } = config[type];
    const hasEnrolls = enrollsInPeriod?.academic_programs?.some(ap => ap[formativeActionsKey]?.length > 0);
    const hasMultipleAcademicPrograms = enrollsInPeriod?.academic_programs?.length > 1;
    const outOfPeriod = type === 'pending' && new Date() > enrollsInPeriod?.postponement_end_date;
    const allowAction = (type === 'postponed' && enrollsInPeriod?.allow_resume_enroll) || (type === 'pending' && !outOfPeriod);

    const renderInfoMessage = () => {
        if (!hasEnrolls) return <p>{noEnrollsText}</p>;

        if (type === 'pending') {
            if (outOfPeriod) return <p>{t('El periodo para solicitar el aplazamiento ha expirado')}</p>;

            if (enrollsInPeriod.postponement_end_date) {
                const [day, month, year] = formatDateLong(enrollsInPeriod.postponement_end_date);
                const dateString = `${day} de ${month} de ${year}`;
                const text = t('postponement_period_end_date').replace('{end_date}', dateString);

                return (
                    <AlertBox type="info" className="m-top">
                        <span dangerouslySetInnerHTML={{ __html: text }} />
                    </AlertBox>
                );
            }
        }

        if (type === 'postponed' && enrollsInPeriod.resume_enroll_date) {
            const [, month, year] = formatDateLong(enrollsInPeriod.resume_enroll_date);
            const dateString = `${month} de ${year}`;
            const text = t('resume_enroll_date').replace('{end_date}', dateString);
            return <p>{text}</p>;
        }

        return null;
    };

    return (
        <div>
            <h2 className={className}>{title}</h2>
            {renderInfoMessage()}
            {!outOfPeriod && enrollsInPeriod?.academic_programs?.map(ap => (
                <Fragment key={ap.academic_program_id}>
                    {hasMultipleAcademicPrograms && <h3>{ap.academic_program_title}</h3>}
                    {ap[formativeActionsKey]?.map(e => (
                        <Card className="m-top" smOnly={false} key={e.formative_action_code}>
                            <div className="d-flex flex-space-between flex-column sm-no-flex-column">
                                <div className="sm-col-70">
                                    <div className="t-upper font-color-879CA1 font-14">{e.formative_action_code}</div>
                                    <div className="font-20 m-top-half">{e.formative_action_title}</div>
                                </div>
                                {allowAction && (
                                    <div className="sm-col-30 d-flex flex-center-y m-top sm-no-m-top">
                                        <ButtonGhost className="t-upper full-width font-14" onClick={() => onAction({ ...e, resume_enroll_date: enrollsInPeriod.resume_enroll_date })}>
                                            {buttonText}
                                        </ButtonGhost>
                                    </div>
                                )}
                            </div>
                        </Card>
                    ))}
                </Fragment>
            ))}
        </div>
    );
}
